import { getBaseApiUrlForEnv, getFirebaseConfig, getSplitConfig } from "./utils"

export const environment = {
  production: true,
  firebaseConfig: getFirebaseConfig("production"),
  baseApiUrl: getBaseApiUrlForEnv(),
  splitAPIKey: getSplitConfig("production"),
}
